import React, { createContext, useReducer } from "react";
import { colorReducer } from "../reducers/colorReducer";

export const ColorContext = createContext();

const ColorContextProvider = (props) => {
  const [colors, dispatch] = useReducer(
    colorReducer, {
        textColor: '#FCDC00',
        backgroundColor: '#194D33',
        logoColor: '#ffffff'
    }
  );
  return (
    <ColorContext.Provider value={{ colors, dispatch }}>
      {props.children}
    </ColorContext.Provider>
  );
};

export default ColorContextProvider;
